import { z } from 'zod';
export const pipelineTerminalStatuses = [
    'merged',
    'deployed',
    'failed',
    'cancelled',
    'needs_human',
    'partial_failure',
    'dismissed',
];
export const pipelineActiveStatuses = [
    'pending',
    'discovering',
    'routing',
    'specifying',
    // Statuses emitted by live phase handlers (ocn-S263-P2)
    'speccing',
    'waiting_for_input',
    'decomposing',
    'ci_running',
    'ready_to_merge',
    // End ocn-S263-P2 additions
    'implementing',
    'reviewing',
    'testing',
    'ci_fixing',
    'enriching',
    'merging',
    'deploying',
    'claimed',
    'running',
];
export const pipelineFailureReasons = [
    'unknown',
    'pipeline_timeout',
    'user_aborted',
    'ci_failed',
    'agent_failed',
    'review_failed',
    'merge_failed',
    'deploy_failed',
    'cancelled',
];
export const pipelineStatusSchema = z.enum([
    ...pipelineActiveStatuses,
    ...pipelineTerminalStatuses,
]);
export const pipelineFailureReasonSchema = z.enum(pipelineFailureReasons);
export const pipelineStatePatchSchema = z.object({
    status: pipelineStatusSchema.optional(),
    failure_reason: pipelineFailureReasonSchema.nullable().optional(),
    progress_percent: z.number().min(0).max(100).optional(),
    phase: z.string().min(1).max(128).nullable().optional(),
    completed_subtasks: z.number().int().min(0).optional(),
    failed_subtasks: z.number().int().min(0).optional(),
    ci_fix_attempts: z.number().int().min(0).optional(),
    fix_attempt_count: z.number().int().min(0).optional(),
    error_message: z.string().max(4_000).nullable().optional(),
});
export const pipelineEventSchema = z.object({
    run_id: z.string().min(1),
    project_id: z.string().min(1).optional(),
    status: pipelineStatusSchema,
    phase: z.string().min(1).max(128).optional(),
    message: z.string().max(4_000).optional(),
    failure_reason: pipelineFailureReasonSchema.optional(),
    progress_percent: z.number().min(0).max(100).optional(),
    metadata: z.record(z.unknown()).optional(),
    emitted_at: z.coerce.date().default(() => new Date()),
});
export function parsePipelineStatePatch(input) {
    return pipelineStatePatchSchema.parse(input);
}
export function parsePipelineEvent(input) {
    return pipelineEventSchema.parse(input);
}
//# sourceMappingURL=pipeline-state.js.map